import React from 'react'

function ImageIcon({
    className = "w-6 h-6 fill-white"
}) {
    return (
        <svg className={ className } viewBox="0 0 24 24">
            <path d="M19.999 4h-16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-13.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm5.5 10h-7l4-5 1.5 2 3-4 5.5 7h-7z"></path>
        </svg>
    )
}

export default ImageIcon